import React, { useEffect, useState } from "react";
import CreateExpenseHeader from "components/CreateExpenseHeader/CreateExpenseHeader";
import CreatedExpenseGrid from "components/CreatedExpenseGrid/CreatedExpenseGrid";
import CreateNewExpenseGrid from "components/CreateNewExpenseGrid/CreateNewExpenseGrid";
import LoadPanelComponent from "components/LoadPanelComponent/LoadPanelComponent";
import { useHistory } from "react-router-dom";
import { useManagerService, useAuthentication } from "services";
import notify from "devextreme/ui/notify";
import PopupComponent from "components/PopupComponent/PopupComponent";
import { OverLimitExpenseResponse, ValidateExpenseResponse } from "types";
import ValidationDataGrid from "components/ValidationDataGrid/ValidationDataGrid";
import { useScreenSize } from "../../utils/media-query";
import { UserClaims } from "@okta/okta-auth-js";
import { CreateExpenseRequest } from "driverExpense/types/createExpenseRequest";

const CreateExpense = () => {
  const history = useHistory();
  const screenSize = useScreenSize();
  const {
    addImage,
    deleteImage,
    getExpenseTypes,
    createExpense,
    deleteExpense,
    submitExpense,
    GetDriverProfileByUserId,
    validateExpenses,
  } = useManagerService();
  const { getUser } = useAuthentication();
  const { getImage } = useManagerService();

  const [expenseTable, setExpenseTable] = useState<any>([]);
  const [duplicateExpenseData, setDuplicateExpenseData] = useState<
    ValidateExpenseResponse[]
  >([]);

  const [overlimitExpenseData, setOverlimitExpenseData] = useState<
    OverLimitExpenseResponse[]
  >([]);

  const [showValidate, setShowValidate] = useState<boolean>(false);
  const [expenseId, setExpenseId] = useState<any>(null);
  const [loaderParams, setLoaderParams] = useState<any>({
    loadPanelVisible: false,
    showIndicator: true,
    shading: true,
    showPane: true,
    positionId: "",
  });

  const [state, setState] = useState<any>({
    formData: {},
    multiple: false,
    uploadMode: "instantly",
    accept: "image/*",
    currentUser: "",
    imageProfileId: null,
    masterExpenseTypesData: [],
    expenseTypeOptions: {},
  });

  const [isCommentRequired, setIsCommentRequired] = useState(false)
  const [popupVisible, setPopupVisible] = useState<boolean>(false);
  const [receiptPopupVisible, setReceiptPopupVisible] = useState<boolean>(
    false
  );

  useEffect(() => {
    if (state.formData && state.formData.description) {
      const expenseTypeId = state.masterExpenseTypesData.find(
        (elem: any) => elem.description === state.formData.description
      );
      setIsCommentRequired(expenseTypeId?.commentRequired ?? false);
    }
  }, [
    state.formData,
    state.formData.description,
    state.masterExpenseTypesData,
  ]);

  const hideInfo = () => {
    setPopupVisible(false);
  };

  const [imgState, setImgState] = useState<any>({
    selectedFile: [],
    imageProfileId: null,
  });

  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  useEffect(() => {
    const valid = () => 
      !!state.formData?.description &&
      !!state.formData?.requestedAmount &&
      !!state.formData?.receiptDate &&
      (!isCommentRequired || !!state.formData?.comment) &&
      !!imgState.imageProfileId;
      setIsFormValid(valid());
}, [state.formData, imgState, isCommentRequired]);


  const buttonOptions = {
    text: "SAVE",
    type: "default",
    stylingMode: "outlined",
    useSubmitBehavior: true,
    icon: "save",
    width: screenSize.isXSmall ? "50px" : "16vw",
    elementAttr: { id: "create-new-expense-btn" },
   };

  const getImageData: any = async (imageId: any) => await getImage(imageId);

  const handleImagePreview = async (imageProfileId: string) => {
    const response: string = await getImageData(imageProfileId);
    if (response && response.length > 0) {
      setState({
        ...state,
        baseImageValue: response,
        canShowReceipt: true,
      });
      setReceiptPopupVisible(true);
    }
  };

  const handleImageUpload = (e: any) => {
    if (
      e.target &&
      e.target.files &&
      e.target.files[0] &&
      e.target.files[0] != null &&
      e.target.files[0].name.length > 0
    ) {
      e.preventDefault();

      setImgState({
        selectedFile: [],
        imageProfileId: null,
      });

      handleUploadImage(e.target);
    }
  };

  const handleUploadImage = async (data: any) => {
    const imageFormData: any = new FormData();
    const user: UserClaims | undefined = await getUser();
    const file: File = data.files[0];

    console.log("Uploading File:", file);
    
    imageFormData.append("userId", user!.email);
    imageFormData.append("imageFile", file);
    
    setLoaderParams({
      ...loaderParams,
      loadPanelVisible: true,
      positionId: ".dx-last-row",
    });

    try{
      
      const response: any = await addImage(imageFormData);
      
      if (!response || !response.id) {
        throw new Error("Failed to upload image");
      }

      setImgState({
        imageProfileId: response.id,
        selectedFile: data.files,
      });
      notify(
        {
          message: "Image Uploaded successfully!!",
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "success",
        3000
      );
    } catch (error: any) {
      setImgState({selectedFile: [], imageProfileId: null});
      const errorMessage = error?.title || "Failed to upload image";
      notify(
        {
          message: errorMessage,
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "error",
        3000
      );
    } finally {
      setLoaderParams({
        ...loaderParams,
        loadPanelVisible: false,
      });
    }
  };

  const getDriverExpenseTypes = async () => {
    const response: any = await getExpenseTypes();
    setState({
      ...state,
      masterExpenseTypesData: response,
      expenseTypeOptions: {
        items: response.map((expense: any) => expense.description),
        value: state.formData.description,
      },
    });
  };

  const initialize = () => {
    getDriverExpenseTypes();
  };

  useEffect(() => {
    initialize();
  }, []);

  const handleBackNavigation = () => {
    history.push("/expenseapproval");
  };

  const handleSubmitExpense = async () => {
    const submitExpenseForm = expenseTable.map((expense: any) => {
      return {
        id: expense.id,
        comments:
          expense.comments.length !== 0
            ? [
                {
                  id: expense.comments[expense.comments.length - 1]["id"],
                  expenseId:
                    expense.comments[expense.comments.length - 1]["expenseId"],
                  comment:
                    expense.comments[expense.comments.length - 1]["comment"],
                },
              ]
            : [],
      };
    });
    const user: UserClaims | undefined = await getUser();
    setLoaderParams({
      ...loaderParams,
      loadPanelVisible: true,
      positionId: ".content",
    });
    const response = await submitExpense(submitExpenseForm, user!.email!);
    if (!response) return;
    if (response) {
      setLoaderParams({
        ...loaderParams,
        loadPanelVisible: false,
        positionId: "",
      });
      notify(
        {
          message: "Expenses have been Submitted successfully!!",
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "success",
        3000
      );
    }
    history.push("/expenseapproval");
  };

  const createNewExpense = async (request: CreateExpenseRequest) => {
    await setLoaderParams({
      ...loaderParams,
      loadPanelVisible: true,
      positionId: ".dx-datagrid-content",
    });

    try {
      const response: any = await createExpense(request);

      if (!response || response?.expenseStatus?.description !== "Created") {
        const errorMessage = response?.title || "Failed to create expense";
        throw new Error(errorMessage);
      }
  
      await setExpenseTable([
        ...expenseTable,
        {
          ...response,
          comment: response.comments[response.comments.length - 1]["comment"],
        },
      ]);
      notify(
        {
          message: "Expense Created successfully!!",
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "success",
        3000
      );
      setState({ ...state, formData: {} });
      setImgState({ selectedFile: [], imageProfileId: null });
    }
    catch (error:any) {
      const errorMessage = error?.title || "Failed to create expense";
      notify(
        {
          message: errorMessage,
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "error",
        3000
      );
    } finally {
      setLoaderParams({
        ...loaderParams,
        loadPanelVisible: false,
      });
    }
  };

  const closeValidate = () => {
    setShowValidate(false);
    setPopupVisible(false);
  };

  const closeValidateButtonOptions = {
    text: "Close",
    onClick: closeValidate,
  };

  const createNewExpenseByPass = async () => {
    const user: UserClaims | undefined = await getUser();
    const driverRegionCode = await GetDriverProfileByUserId(user!.driverId);
    let tempExpId: any = {};
    if (state.formData && state.formData.description) {
      const expenseTypeId = state.masterExpenseTypesData.find(
        (elem: any) => elem.description === state.formData.description
      );
      tempExpId = expenseTypeId;
    }

    let createExpenseRequest: CreateExpenseRequest = {
      driverEmployeeId: user!.driverId as number,
      expenseTypeId: tempExpId.id,
      receiptDate: state.formData.receiptDate,
      requestedAmount: state.formData.requestedAmount,
      comment: state.formData.comment,
      imageProfileId: imgState.imageProfileId,

      //TODO This will need to be fixed to not need the exclamation points
      userId: user!.email!
    };

    setLoaderParams({
      ...loaderParams,
      loadPanelVisible: true,
      positionId: ".dx-datagrid-rowsview",
    });
    createNewExpense(createExpenseRequest);
    setShowValidate(false);
    setPopupVisible(false);
  };

  const validatePopupOptions = {
    text: "Proceed",
    onClick: createNewExpenseByPass,
    type: "default",
    stylingMode: "default",
  };

  const handleCreateNewExpense = async (e: any) => {
    e.preventDefault();
    const user: UserClaims | undefined = await getUser();
    const driverProfile = await GetDriverProfileByUserId(user!.driverId);
    let tempExpId: any = {};
    if (state.formData && state.formData.description) {
      const expenseTypeId = state.masterExpenseTypesData.find(
        (elem: any) => elem.description === state.formData.description
      );
      tempExpId = expenseTypeId;
    }

    //TODO Remove this and use a real Type/Request
    let tempObj: any = {
      id: 0,
      driverEmployeeId: user!.driverId,
      driverRegionCode: driverProfile.regionCode,
      driverDC: driverProfile.driverDC,
      expenseTypeId: tempExpId.id,
      requestedAmount: state.formData.requestedAmount,
      receiptDate: state.formData.receiptDate,
      imageProfileId: imgState.imageProfileId,
      comments:
        state?.formData?.comment?.length > 0 ||
        state?.formData?.comment !== null ||
        state?.formData?.comment !== undefined
          ? [
              {
                id: 0,
                expenseTypeId: tempExpId.id,
                comment: state.formData.comment,
              },
            ]
          : [],
    };

    let createExpenseRequest: CreateExpenseRequest = {
      driverEmployeeId: user!.driverId as number,
      expenseTypeId: tempExpId.id,
      receiptDate: state.formData.receiptDate,
      requestedAmount: state.formData.requestedAmount,
      comment: state.formData.comment,
      imageProfileId: imgState.imageProfileId,

      //TODO This will need to be fixed to not need the exclamation points
      userId: user!.email!
    };

    const response: any = await validateExpenses(tempObj);
    if (
      response?.duplicateExpenses?.length === 0 &&
      response?.overLimitExpenses?.length === 0
    ) {
      createNewExpense(createExpenseRequest);
    } else {
      if (response?.duplicateExpenses?.length > 0) {
        setDuplicateExpenseData(response?.duplicateExpenses);
      } else if (response?.overLimitExpenses?.length > 0) {
        setOverlimitExpenseData(response?.overLimitExpenses);
      }
      setShowValidate(true);
      setPopupVisible(true);
    }
  };

  const hideLoadPanel = () => {
    setLoaderParams({
      ...loaderParams,
      loadPanelVisible: false,
    });
  };

  function handleDeleteExpense(e: any) {
    const isCanceled = new Promise(async (resolve, reject) => {
      const user: UserClaims | undefined = await getUser();
      if (user) {
        setLoaderParams({
          ...loaderParams,
          loadPanelVisible: true,
          positionId: ".dx-datagrid-rowsview",
        });
        const response: any = await deleteExpense({ id: expenseId }, user!.email!);
        if (response && response.isDeleted === true) {
          resolve(false);
          setLoaderParams({
            ...loaderParams,
            loadPanelVisible: false,
            positionId: "",
          });
          setPopupVisible(false);
          setExpenseTable(
            expenseTable.filter((item: any) => item.id !== expenseId)
          );
          notify(
            {
              message: "Expense Deleted successfully!!",
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "warning",
            3000
          );
        } else {
          reject("failure");
        }
      }
    });
    e.cancel = isCanceled;
  }

  const handleClearImage = async () => {
    const user: UserClaims | undefined = await getUser();
    const response: any = await deleteImage({
      id: imgState.imageProfileId,
      userId: user!.email,
    });
    if (response && response.isDeleted === true) {
      setImgState({
        selectedFile: [],
        imageProfileId: null,
      });

      notify(
        {
          message: "Image Deleted successfully!!",
          position: {
            my: "center top",
            at: "center top",
          },
        },
        "success",
        3000
      );
    }
  };

  const openDeleteConfirm = async (e: any) => {
    await setExpenseId(e.key);
    setPopupVisible(true);
  };

  const hideReceiptInfo = () => {
    setReceiptPopupVisible(false);
  };

  const closeReceiptImageButtonOptions = {
    text: "Close",
    onClick: hideReceiptInfo,
  };

  return (
    <div>
      <CreateExpenseHeader
        handleBackNavigation={handleBackNavigation}
        handleSubmitExpense={handleSubmitExpense}
        expenseTable={expenseTable}
      />
      <hr />
      <CreateNewExpenseGrid
        formData={state.formData}
        handleCreateNewExpense={handleCreateNewExpense}
        buttonOptions={buttonOptions}
        positionOptions={state.expenseTypeOptions}
        handleImageUpload={handleImageUpload}
        imgState={imgState}
        hideReceiptInfo={hideReceiptInfo}
        closeButtonOptions={closeReceiptImageButtonOptions}
        canShowReceipt={state.canShowReceipt}
        baseImageValue={state.baseImageValue}
        handleClearImage={handleClearImage}
        handleImagePreview={handleImagePreview}
        popupVisible={receiptPopupVisible}
        isCommentRequired={isCommentRequired}
      />

      <CreatedExpenseGrid
        expenseTable={expenseTable}
        handleDeleteExpense={handleDeleteExpense}
        popupVisible={popupVisible}
        hideInfo={hideInfo}
        showValidate={showValidate}
        openDeleteConfirm={openDeleteConfirm}
      />

      <LoadPanelComponent
        hideLoadPanel={hideLoadPanel}
        loadPanelVisible={loaderParams.loadPanelVisible}
        showIndicator={loaderParams.showIndicator}
        shading={loaderParams.shading}
        showPane={loaderParams.showPane}
        positionId={loaderParams.positionId}
      />
      {showValidate && (
        <PopupComponent
          submitButtonOptions={validatePopupOptions}
          popupVisible={popupVisible}
          hideInfo={hideInfo}
          closeButtonOptions={closeValidateButtonOptions}
          title="Validation Result"
        >
          <ValidationDataGrid
            duplicateExpenseData={duplicateExpenseData}
            overlimitExpenseData={overlimitExpenseData}
          />
        </PopupComponent>
      )}
    </div>
  );
};

export default CreateExpense;
